import { useEffect, useRef, useState } from "react";
import { AppCard } from "../../components/app-card";
import { AddAppDialog } from "../../components/add-app-dialog";
import { EditVersionDialog } from "../../components/edit-version-dialog";
import { Button } from "../../components/ui/button";
import { Plus, Package } from "lucide-react";
import { toast } from "sonner";
import { Toaster } from "../../components/ui/sonner";
import { CallAPIGetPromise } from "Common/commaon";
import "./version-control.css";



export default function VersionControl() {
  const [apps, setApps] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
 const [refresh,setRefresh]=useState(false)
  const filteredApps = apps.filter((app) =>
    app.app_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddApp = (newApp) => {
    setApps([...apps, newApp]);
    toast.success(`${newApp.name} has been added successfully!`);
  };

  const handleEditVersion = (app, platform) => {
    setSelectedApp(app);
    setSelectedPlatform(platform);
    setEditDialogOpen(true);
  };

  const handleSaveVersion = (
    appId,
    platform,
    data
  ) => {
  
    const platformName = platform === "ios" ? "iOS" : "Android";
    toast.success(`${platformName} version updated to ${data.version}!`);
    setRefresh(r=>!r)
  };
  const formRef = useRef(null);

  const handleViewHistory = (app) => {
    setSelectedApp(app);
    setHistoryDialogOpen(true);
  };
  useEffect(()=>{
    CallAPIGetPromise("/admin/listApp").then((res)=>{
      console.log(res)
 if(res?.success){
  setApps(res.data)
 }
})
  },[refresh])

  return (
    <div
    ref={formRef}
    className="page-content tailwind-prefix version-control-page"
  >
      <div className="version-control-shell text-sm w-full">
      <Toaster />

      <div className="version-control-toolbar">
        <div>
          <h2>App releases</h2>
          <p>Manage mobile versions, release stages, and required updates.</p>
        </div>
        <Button className="version-control-add" onClick={() => setAddDialogOpen(true)}>
              <Plus className="w-4 h-4 mr-2" />
              Add App
        </Button>
      </div>

        {/* Stats Cards */}
        <div className="version-control-stats grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4">
          <div className="version-control-stat">
            <div className="version-control-stat-label">Total Apps</div>
            <div className="version-control-stat-value">{apps.length}</div>
          </div>
          <div className="version-control-stat">
            <div className="version-control-stat-label">In Development</div>
            <div className="version-control-stat-value is-development">
              {apps.filter((a) => a.ios_status === "development" || a.android_status === "development").length}
            </div>
          </div>
          <div className="version-control-stat">
            <div className="version-control-stat-label">In Testing</div>
            <div className="version-control-stat-value is-testing">
              {apps.filter((a) => a.ios_status === "testing" || a.android_status === "testing").length}
            </div>
          </div>
          <div className="version-control-stat">
            <div className="version-control-stat-label">In Production</div>
            <div className="version-control-stat-value is-production">
              {apps.filter((a) => a.ios_status === "production" && a.android_status === "production").length}
            </div>
          </div>
        </div>

        {/* App Grid */}
        {filteredApps.length === 0 ? (
          <div className="version-control-empty text-center">
            <Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="font-medium text-gray-900 mb-2">No apps found</h3>
            <p className="text-gray-500 mb-4">
              {searchQuery ? "Try a different search term" : "Get started by adding your first app"}
            </p>
            {!searchQuery && (
              <Button onClick={() => setAddDialogOpen(true)}>
                <Plus className="w-4 h-4 mr-2" />
                Add App
              </Button>
            )}
          </div>
        ) : (
          <div className="version-control-grid">
            {filteredApps.map((app) => (
              <AppCard
                key={app.id}
                app={app}
                onEdit={handleEditVersion}
                onViewHistory={handleViewHistory}
              />
            ))}
          </div>
        )}
      {/* Dialogs */}
      <AddAppDialog
        open={addDialogOpen}
        onOpenChange={setAddDialogOpen}
        onAdd={handleAddApp}
      />
      <EditVersionDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        app={selectedApp}
        platform={selectedPlatform}
        onSave={handleSaveVersion}
      />
     </div>
    </div>
  );
}
